module.exports = __webpack_public_path__ + "static/media/30.094f6765.svg";